import { z } from 'zod/v4-mini';
import { mutationProcedure } from '../trpc/common.js';
import { notifyReload } from '../utilities/notifyReload.js';
import type { ApiParams } from '../types/ApiParams.js';
import type { TaskDescription } from '../types/TaskDescription.js';
import { matchingZodObject } from '../utilities/matchingZodObject.js';

export type RestartTaskInput = Pick<TaskDescription, 'id' | 'inputPath'>;
const ZodRestartTaskInput = matchingZodObject<RestartTaskInput>({
  id: z.string(),
  inputPath: z.string(),
});

/**
 * Remove the record of a specific task (usually bundle result) and notify the client to reload,
 * which will trigger the task to be re-run.
 */
export async function restartTask(
  params: ApiParams<RestartTaskInput, 'bus' | 'taskRunner' | 'telemetryClient', 'incrementTargetVersion' | 'sequence'>,
): Promise<void> {
  const { input, ctx } = params;
  const { id, inputPath } = input;
  const { session, bus, taskRunner, telemetryClient } = ctx;

  console.debug(`ApiServer: Restarting task ${id}`);
  await taskRunner.clearResult(id);
  session.incrementTargetVersion(inputPath);
  await notifyReload({ reason: 'restart-task' }, { bus, session, telemetryClient });
}

// Attach a trpc procedure to the function.
restartTask.procedure = mutationProcedure<RestartTaskInput, void>(restartTask, ZodRestartTaskInput, z.void());
